export const convertMillisecondsToRealTime = (milliseconds: number): string => {
  // Convertir milisegundos a segundos
  const seconds = milliseconds / 1000;

  // Calcular horas, minutos y segundos
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  // Formatear el resultado en hh:mm:ss
  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};
